import React from 'react';
import styles from './ColGroup.less';

export default function() {
  return (
    <colgroup className={styles.root}>
      <col className="col-1" />
      <col className="col-2" />
      <col className="col-3" />
      <col className="col-4" />
      <col className="col-5" />
      <col className="col-6" />
    </colgroup>
  );
}



// WEBPACK FOOTER //
// ./src/routes/Merchant/Order/Table/ColGroup.js